// removed by extract-text-webpack-plugin
module.exports = {"attendee-header":"_3gBlFFVL_ _2l0xl0HVf reSGZpUaK xBrMYP3IH _1lCmGBorg _1B4qcaoCi iNGToVUbh _23s7Mrdy_ _2ZDRZa8To _2Ws23qNID","title":"U-_BHJqFQ _1yJuXbiru _1FTxuUfut _1yThnDgzj _3-7RXEMuO _34skhd3lM _1C-lRJLgc eQmKwyjT2 hxreTUKKY _76colo4FN _2OFVW-wzu _1-ov2DQLe YXYmy67R7 _2HOZDFp6P _2_tabFk6j ODSLv4a7K _1JAgybqD3 _6yTQLo9ug","text":"BnKKPgC0M _2l0xl0HVf _1yJuXbiru _2LQmf5WSW _1gHeemEDk _1BE2U7F8v m_MD8dOe5 hxreTUKKY _2OFVW-wzu _1-ov2DQLe YXYmy67R7 _2HOZDFp6P _2_tabFk6j _2tvY6e7Hw _38xhTaw38 NtaDwUdHI","actions":"_237BylX7A _1SzzIo45S","download":"_1zKo3KfEg _3fIeCGwgt"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/attendee-header/attendee-header.css
 ** module id = 2081
 ** module chunks = 0
 **/